<template>
  <v-card class="pb-3">
    <v-card-title>
      <div class="text-h6 align-baseline text-center full-width">
        Notifications for
        <span class="text-h6">{{ orderName }}</span>
        <v-btn icon class="close-button elevation-0" @click="cancelDialog">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text>
      <v-expand-transition :hide-on-leave="false" mode="out-in">
        <v-form v-model="isValid" class="mx-3">
          <v-row no-gutter>
            <v-col cols="3">
              <v-checkbox
                v-model="notificationprotocopy.active"
                label="Active"
              ></v-checkbox
            ></v-col>
            <v-col cols="5">
              How Many Notifications?<v-text-field
                v-model.number="notificationprotocopy.notify_count"
                single-line
                type="number"
                label="test"
              />
            </v-col>
            <v-col cols="4">
              Notify every
              <v-text-field
                v-model.number="notificationprotocopy.period"
                single-line
                type="number"
                label="test"
              />
              days
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-text-field
                label="Note"
                v-model="notificationprotocopy.content"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-expand-transition>
      <v-divider class="my-2"></v-divider>
    </v-card-text>
    <v-card-actions class="justify-space-between">
      <v-btn outlined @click="cancelDialog">Cancel</v-btn>
      <v-btn color="primary" @click="submitChanges" :disabled="!canSubmit">
        Done
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import cloneDeep from "lodash/cloneDeep";

export default {
  props: {
    selectedRecord: Object,
    existingNotification: Object,
    notificationproto: Object,
    orderName: String,
    orderId: String,
    editMode: Boolean
  },
  name: "AddEditNotifications",
  data() {
    return {
      today: new Date().toISOString(),
      notificationType: "",
      notificationRecipients: [],
      notificationNote: "",
      notificationIndex: -1,
      isSubmitting: false,
      orderExpiryChoice: false,
      orderExpiryDatetime: "",
      orderExpiryTimes: "",
      orderFrequency: "",
      showNewNotification: false,
      showCal: false,
      isValid: false,
      search: "",
      notifications: [],
      expanded: {},
      notificationprotocopy: {}
    };
  },
  created() {
    this.types = [
      { text: "Daily", value: "1 days" },
      { text: "Weekly", value: "7 days" },
      { text: "Bi-Weekly", value: "14 days" },
      { text: "Monthly", value: "1 month" }
    ];
    this.recipients = [
      { text: "Me", value: "me" },
      { text: "Patient", value: "patient" }
    ];
  },
  mounted() {
    this.notificationprotocopy = this.notificationproto;

    if (this.editMode) {
      this.existingNotification.notification_id = this.existingNotification._id;
      this.notificationprotocopy = this.existingNotification;
    }
  },
  computed: {
    ...mapGetters("allUoms", { units: "list" }, { root: true }),
    canSubmit() {
      return !(this.notificationIndex !== -1 || this.showNewNotification);
    }
  },
  methods: {
    cancelDialog() {
      // Put up an "Are you sure?" dialog of some sort
      if (
        !this.canSubmit &&
        !window.confirm("Are you sure you want to cancel?")
      ) {
        return;
      }
      this.$emit("cancel-this-dialog");
    },
    getItemColor(item) {
      // return item.value ? '#78909C' : '#039BE5';
      return "#78909C";
    },
    findUOM(id) {
      const item = this.units.find(unit => unit._id === id);
      return item ? item.name : "";
    },
    findUOMId(name) {
      const item = this.units.find(unit => unit.name === name);
      return item ? item._id : "";
    },
    getConditionText(condition) {
      switch (condition.ctype) {
        case "frequency":
          const uom = this.findUOM(condition.when.every);
          return `${condition.count} ${uom}`;
        default:
          return "Unknown condition type";
      }
    },
    newNotification() {
      this.notificationNote = "";
      this.notificationRecipients = [];
      this.notificationType = "";
      this.notificationIndex = -1;
      this.showNewNotification = true;
    },
    editNotification(index) {
      if (this.notifications[index]) {
        this.notificationNote = this.notifications[index].note;
        this.notificationRecipients = this.notifications[
          index
        ].recipients.concat();
        this.notificationType = this.getConditionText(
          this.notifications[index].conditions
        );
        this.notificationIndex = index;
        this.showNewNotification = false;
      }
    },
    addOrUpdateNotification() {
      const pieces = this.notificationType.split(" ");
      if (this.notificationIndex === -1) {
        // No existing notification
        const item = {
          record_id: this.selectedRecord._id,
          order_id: this.orderId,
          conditions: {
            count: pieces[0],
            ctype: "frequency",
            when: {
              every: this.findUOMId(pieces[1])
            }
          },
          note: this.notificationNote,
          recipients: this.notificationRecipients.map(r =>
            r.value ? r.value : r
          ),
          action: "NEW"
        };
        this.notifications.push(item);
      } else {
        const index = this.notificationIndex;
        this.notifications[index].note = this.notificationNote;
        this.notifications[
          index
        ].recipients = this.notificationRecipients.map(r =>
          r.value ? r.value : r
        );
        this.notifications[index].conditions.count = pieces[0];
        const uom = (this.notifications[
          index
        ].conditions.when.every = this.findUOMId(pieces[1]));
        // this.notifications[index].action = 'EDIT';
        this.$set(this.notifications[index], "action", "EDIT");
      }
      this.notificationIndex = -1;
      this.showNewNotification = false;
    },
    deleteNotification(index) {
      if (
        this.notifications[index] &&
        window.confirm("Are you sure you want to delete this notification?")
      ) {
        this.$set(this.notifications[index], "action", "DELETE");
        // this.notifications.splice(index, 1);
        this.notificationIndex = -1;
        this.showNewNotification = false;
      }
    },
    unDeleteNotification(index) {
      this.$delete(this.notifications[index], "action");
      // this.notifications.splice(index, 1);
      this.notificationIndex = -1;
      this.showNewNotification = false;
    },
    submitChanges() {
      this.$emit("update-notifications", this.notificationprotocopy);
    },
    toggleExpandNote(index) {
      if (this.expanded[index]) {
        this.expanded[index] = !this.expanded[index];
      } else {
        this.$set(this.expanded, index, true);
      }
    }
  },
  watch: {}
};
</script>

<style scoped lang="scss">
.close-button {
  position: absolute;
  right: 0px;
  cursor: pointer;
  z-index: 200;
  margin-top: -10px;
}
.name-center {
  text-align: center;
}
.full-width {
  width: 100%;
}
.deleted {
  opacity: 0.8;
  font-style: italic;
}
.open {
  transform: rotate(90deg);
  transition: rotate 2s;
}
</style>
